import { resources } from "../../utils/resources";
import { sharedData } from "../../utils/sharedData";
import "./index.css";

const RewardPopup = ({ type, onClose, showReward }) => {
	return (
		<div className="popup-container">
			<div className="popup-content">
				<p style={{ color: "#000" }}>{resources[sharedData.lang][type]}</p>

				<div style={{ textAlign: "center", marginTop: 24 }}>
					<button className="popup-btn" onClick={onClose} style={{ background: "red" }}>
						{resources[sharedData.lang].no}
					</button>
					<button className="popup-btn" onClick={showReward} style={{ background: "green" }}>
						{resources[sharedData.lang].yes}
					</button>
				</div>
			</div>
		</div>
	);
};

export default RewardPopup;
